export default defineNuxtPlugin(() => {
  // Плагин для оптимизации критических ресурсов
  if (process.client) {
    // Предзагрузка критических изображений (только существующие)
    const criticalImages = [
      '/logo.svg',
      '/sx/Cloud.png'
    ]
    
    criticalImages.forEach(src => {
      const link = document.createElement('link')
      link.rel = 'preload'
      link.href = src
      link.as = 'image'
      document.head.appendChild(link)
    })
    
    // Preload критических шрифтов для быстрой загрузки
    const criticalFonts = [
      '/assets/fonts/alsHauss/ALSHauss-Regular.woff',
      '/assets/fonts/alsHauss/ALSHauss-Medium.woff',
      '/assets/fonts/alsHauss/ALSHauss-Bold.woff'
    ]
    
    criticalFonts.forEach(fontSrc => {
      const fontLink = document.createElement('link')
      fontLink.rel = 'preload'
      fontLink.href = fontSrc
      fontLink.as = 'font'
      fontLink.type = 'font/woff'
      fontLink.crossOrigin = 'anonymous'
      document.head.appendChild(fontLink)
    })
  }
})
